var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("ログイン")]),_vm._v(" "),_c('button',{on:{"click":_vm.signInWithTwitter}},[_vm._v("Sign in with Twitter")]),_vm._v(" "),_c('a',{attrs:{"href":"https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri"}},[_vm._v("Sign in with Line")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec62177c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/SnsLogin.vue
// module id = null
// module chunks = 